'use client';

import { Box, Typography } from '@wishket/design-system';
import Link from 'next/link';

import { PATH } from '@/shared/constants';

interface SideRecentPostCardProps {
  category: string;
  categoryFlag?: string;
  title: string;
  href: string;
}

const SideRecentPostCard = ({
  category,
  categoryFlag,
  title,
  href,
}: SideRecentPostCardProps) => {
  return (
    <Box className="flex flex-col gap-1">
      <Box className="flex">
        <Link href={`${PATH.LIST}/${categoryFlag}`} className="w-fit">
          <Typography
            variant="body2"
            className="font-medium text-w-gray-600 hover:underline"
          >
            {category}
          </Typography>
        </Link>
        <Link href={href} className="flex-1" />
      </Box>
      <Link href={href}>
        <Typography
          variant="body2"
          className="line-clamp-2 font-medium text-w-gray-900 hover:underline"
        >
          {title}
        </Typography>
      </Link>
    </Box>
  );
};

export default SideRecentPostCard;
